import PropTypes from "prop-types";
import React, { Component } from "react";
import { RegistrationShape, isMember, sortAndFilterMembers } from "../../utils";
import Registration from "./Registration";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 4;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // change background colour if dragging
  background: isDragging ? "rba(0,0,0,0.4)" : "transparent",

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "transparent",
  padding: grid,
});

class Queue extends Component {
  constructor(props) {
    super(props);
    this.sortUsers = [];
    this.handleGroupRegistration = this.handleGroupRegistration.bind(this);
    this.handleQuickAdd = this.handleQuickAdd.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  handleGroupRegistration() {
    const { onGroupRegistration, selectedUserInQueue, location } = this.props;
    onGroupRegistration(location, selectedUserInQueue);
  }

  handleQuickAdd() {
    this.props.onUpdateQuickAddDrawerVisibility(true);
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const { location } = this.props;

    const items = reorder(
      this.sortUsers,
      result.source.index,
      result.destination.index
    );
    this.sortUsers = items;
    this.props.onUpdateQueueOrder(location, items);
  }

  render() {
    const { className, queueUsers, isLoading } = this.props;

    // member user on top, order user by time ascending
    this.sortUsers = [];
    if (queueUsers.length > 0) {
      //convert to native array to do custom sort
      const reorderedUsers = []
        .concat(queueUsers)
        .filter((_) => "reorderIndex" in _)
        .sort((a, b) => a.reorderIndex - b.reorderIndex);

      const memberUsers = sortAndFilterMembers(queueUsers);

      this.sortUsers = memberUsers.concat(reorderedUsers);

      const noneMemberUsers = []
        .concat(queueUsers)
        .filter((u) => !("reorderIndex" in u) && !isMember(u))
        .sort((a, b) => a.timestamp - b.timestamp);

      this.sortUsers = this.sortUsers.concat(noneMemberUsers);
    }

    return isLoading ? (
      <div />
    ) : (
      <div className={className}>
        <div
          className="md-cell md-cell--12 staff-page--headline"
          style={{ position: "relative" }}
        >
          QUEUE {queueUsers.length > 0 && `(${queueUsers.length})`}
          {/* right align the button, using an <a> so the vertical is similar with other child */}
          {/*
          <a
            onClick={this.handleQuickAdd}
            style={{ position: "absolute", right: 20, cursor: "pointer" }}
          >
            {" "}
            Quick Add
          </a> */}
        </div>
        {queueUsers.length > 0 ? (
          <div className="md-cell md-cell--12 queue-column--users">
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="droppable">
                {(droppableProvided, droppableSnapshot) => (
                  <div
                    ref={droppableProvided.innerRef}
                    style={getListStyle(droppableSnapshot.isDraggingOver)}
                  >
                    {this.sortUsers.map((registration, index) => (
                      <Draggable
                        key={registration.registrationId}
                        draggableId={registration.registrationId}
                        index={index}
                      >
                        {(draggableProvided, draggableSnapshot) => (
                          <div>
                            <div
                              ref={draggableProvided.innerRef}
                              {...draggableProvided.draggableProps}
                              {...draggableProvided.dragHandleProps}
                              style={getItemStyle(
                                draggableSnapshot.isDragging,
                                draggableProvided.draggableProps.style
                              )}
                            >
                              <Registration
                                ref={draggableProvided.innerRef}
                                {...draggableProvided.draggableProps}
                                {...draggableProvided.dragHandleProps}
                                style={getItemStyle(
                                  draggableSnapshot.isDragging,
                                  draggableProvided.draggableProps.style
                                )}
                                registration={registration}
                              />
                            </div>
                            {draggableProvided.placeholder}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {droppableProvided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        ) : (
          <div className="md-cell md-cell--12 queue-column--users">
            <div
              className="md-grid"
              style={{
                display: "flex",
                height: "calc(100% - 10px)",
                textAlign: "center",
                marginLeft: 10,
                marginRight: 10,
                marginBottom: 10,
                backgroundColor: "grey",
                color: "white",
              }}
            >
              <div className="md-cell md-cell--12 md-cell--middle">Empty</div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Queue.propTypes = {
  onUpdateQueueOrder: PropTypes.func.isRequired,
  onGroupRegistration: PropTypes.func.isRequired,
  selectedUserInQueue: RegistrationShape,
  location: PropTypes.string.isRequired,
  className: PropTypes.string,
  queueUsers: PropTypes.arrayOf(RegistrationShape),
  isLoading: PropTypes.bool.isRequired,
};

Queue.defaultProps = {
  queueUsers: [],
  selectedUserInQueue: null,
  className: null,
};

export default Queue;



// WEBPACK FOOTER //
// ./src/staff/components/Queue/Queue.jsx